import React, {useCallback, useEffect, useState} from "react";
import {
    getHarvestProjectByProjectId, getHarvestProjectsByClientID,
} from "../../utilities/harvestAPI";
import keycloak from "../../Keycloak";
import Autocomplete from "@mui/material/Autocomplete";
import { InputAdornment, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import DropdownPaper from "../General/DropdownPaper";


export let projectStartDate;
export let projectEndDate;
export let timeRetainer;

export let selectedHarvestProjectId

let inputLabelProps;


const HarvestProjectSearch = ({harvestClientId, harvestProjectId,harvestProjectName, onChangeMethod}) => {
    const style = {
        "& label.Mui-focused": {
            color: "#FF6600",
        },
        "& .MuiOutlinedInput-root": {
            "&.Mui-focused fieldset": {
                borderColor: "#FF6600",
            },
        },
    };

    const [projectNames, setProjectNames] = useState([]);

    const harvestProjects = useCallback(() => {
        getHarvestProjectsByClientID(harvestClientId, keycloak.token).then((projects) => {
        if (projects.length > 0) {
            console.log(projects);
            const projectNames = projects.map((project) => ({
                id: project.id,
                projectId: project.projectId,
                name: project.name
            }));
            setProjectNames(projectNames);
            console.log("Project names: ", projectNames);
            console.log(...projects)
        } else {
            setProjectNames([]);
            console.log("No data returned");
        }
    })
    },[harvestClientId]);

    const switchVisibility = () => {
        document.getElementById("progressSpinner").hidden = true;
        document.getElementById("projectDetailsBox").hidden = false;
    }

    useEffect(() => {
        harvestProjects();
    }, [harvestProjects])

    const onChangeHandler = async (event, value) => {
        if (value) {
            const project = await getHarvestProjectByProjectId(value.projectId, keycloak.token);
            selectedHarvestProjectId = project[0].id;
            onChangeMethod(value.id);
            if (project) {
                projectStartDate = project[0].startsOn;
                projectEndDate = project[0].endsOn;
                timeRetainer = project[0].budget;

                document.getElementById("progressSpinner").hidden = false;
                document.getElementById("projectDetailsBox").hidden = true;

                setTimeout(() => {
                    switchVisibility()
                }, 1000);

                document.getElementById("startDate").value = projectStartDate;
                document.getElementById("endDate").value = projectEndDate;
                document.getElementById("timeRetainer").value = timeRetainer;
            }
        }
    }

    return (
        <Autocomplete
            PaperComponent={DropdownPaper}
            data-testid='HarvestProjectAutoComplete'
            options={projectNames}
            defaultValue={harvestProjectId && harvestProjectName ? { id: harvestProjectId, name: harvestProjectName } : null}
            getOptionLabel={(option) => option.name}
            onChange={onChangeHandler}
            id="harvestProject"
            getOptionSelected={(option, value) => option.id === value.projectId}
            renderInput={(params) => (
                <TextField
                    required
                    {...params}
                    label={params?.label ?? "Project name"}
                    variant="outlined"
                    default value = "Search Harvest"
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <React.Fragment>
                                {params.InputProps.endAdornment}
                                <InputAdornment position="end" >
                                    <SearchIcon />
                                </InputAdornment>
                            </React.Fragment>
                        ),
                    }}
                    InputLabelProps={{
                        shrink: inputLabelProps,
                    }}
                    className="inputWidth"
                    sx={style}
                />
            )}
        />
    )
};
export default HarvestProjectSearch;